module.exports = __webpack_public_path__ + "img/home-bg.66e41975.png";